import { createFileRoute } from '@tanstack/react-router';
import { FleetBookingHub } from '@/features/fleet/FleetBookingHub';

export const Route = createFileRoute('/_app/vehicle-bookings')({ component: FleetBookingHub });

// Prenotazioni mezzi (vehicle-booking enterprise, BE v1.60): risorsa vehicle-bookings con
// workflow a 8 stati su endpoint dedicati (pm-approve/pm-reject/assign-vehicle/start-trip/
// complete-trip/cancel) + sotto-risorsa vehicle-booking-participants. Indipendente dal
// booking legacy /api/bookings.
